import React, { useState } from "react";
import { X } from "lucide-react";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 px-4 relative z-40">
      <div className="max-w-7xl mx-auto flex items-center justify-center relative">
        <p className="text-sm md:text-base font-medium text-center pr-8">
          UM Groupe reconnu parmi les leaders des solutions énergétiques innovantes 2025.
          <a href="#contact" className="ml-2 underline hover:no-underline">
            En savoir plus
          </a>
        </p>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsVisible(false);
          }}
          className="absolute right-0 top-1/2 -translate-y-1/2 hover:bg-orange-700/50 rounded p-1 transition-colors cursor-pointer z-50"
          aria-label="Fermer"
          type="button"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;